import React from 'react';
import SecVideoListItem from './SecVideoListItem';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

const SecVideoList = () => {
  return (
    <>
      <div className="video-layout">
        <div className="container">
          <div className="video-layout-header">
            <h2 className="video-layout-title">Silicon Slopes Summit</h2>
            <a className="btn-viewAll" href="/">View playlist</a>
          </div>
        </div>
        <div className="video-layout-list">
          <Swiper
            spaceBetween={20}
            slidesPerView={5}
          >
            <SwiperSlide>
              <SecVideoListItem />
            </SwiperSlide>
            <SwiperSlide>
              <SecVideoListItem />
            </SwiperSlide>
            <SwiperSlide>
              <SecVideoListItem />
            </SwiperSlide>
            <SwiperSlide>
              <SecVideoListItem />
            </SwiperSlide>
            <SwiperSlide>
              <SecVideoListItem />
            </SwiperSlide>
            <SwiperSlide>
              <SecVideoListItem />
            </SwiperSlide>
            <SwiperSlide>
              <SecVideoListItem />
            </SwiperSlide>
            <SwiperSlide>
              <SecVideoListItem />
            </SwiperSlide>
            <SwiperSlide>
              <SecVideoListItem />
            </SwiperSlide>
            <SwiperSlide>
              <SecVideoListItem />
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </>
  );
};

export default SecVideoList;